var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import * as insightsAPI from '@debbie/cortex/dist/api/insights';
import { PlaceholderLoader } from '../';
import ExternalLink from '../Icons/ExternalLink';
const CaseFilterQueue = (props) => {
    const caseFilter = useSelector((s) => s.caseFilter);
    const [loading, setLoading] = useState(false);
    return loading ? (React.createElement(PlaceholderLoader, { width: "16px", height: "15px", inline: true })) : (React.createElement(ExternalLink, { style: { margin: '0.2em 0 -0.2em', cursor: 'pointer' }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const caseQueue = yield insightsAPI.getCaseFilterQueue(Object.assign(Object.assign({}, caseFilter), props.appendToCaseFilter));
            c.redirect.redirect(`/cases/${caseQueue.join(',')}`);
            setLoading(false);
        }), id: "ui-test-5e51e31e" }));
};
export default CaseFilterQueue;
//# sourceMappingURL=CaseFilterQueue.js.map